// extracted by mini-css-extract-plugin
export default {"formContent":"Select_formContent__gA3xe","error":"Select_error__JRT9x","fadeIn":"Select_fadeIn__PT77j","formLabel":"Select_formLabel__6feEI","formSelect":"Select_formSelect__q6csy"};